import { __assign } from '../../external/tslib/tslib.es6.mjs.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { CarIcon } from '../../icons/CarIcon.js';
import { Tag } from '../tag/Tag.js';
import styles from './VehicleQuote.module.scss.js';

var VehicleQuote = function (_a) {
    var value = _a.value, vin = _a.vin, name = _a.name;
    return (jsxs("div", __assign({ className: styles.wrapper }, { children: [jsx("div", __assign({ className: styles.iconWrapper }, { children: jsx(CarIcon, {}) })), jsxs("div", __assign({ className: styles.detailsWrapper }, { children: [jsx(Tag, { className: styles.tag }), jsx("p", __assign({ className: styles.vehicle }, { children: name })), jsxs("div", { children: [jsxs("p", __assign({ className: styles.details }, { children: ["Value: ", value] })), jsxs("p", __assign({ className: styles.details }, { children: ["VIN: ", vin] }))] })] }))] })));
};

export { VehicleQuote };
